export default "__VITE_ASSET___ebGAmDM__"